import { createAction } from "redux-actions";

import * as types from "./types";

export const receiveRoles = createAction(types.RECEIVE_ROLES, ({ roles }) => ({
  roles,
}));
